/*
 * Find in Store drawer
 * Lazy-loads the Anagram dealer-locator experience the first time a drawer
 * opens, so the third-party boot.js is not requested on every PDP and mounts
 * while the drawer is visible. One observer per buy_buttons block.
 */
document.querySelectorAll('.find-in-store-modal__embed[data-anagram-experience]').forEach((embed) => {
  const modal = embed.closest('modal-dialog');
  if (!modal) return;

  let booted = false;
  const bootExperience = () => {
    if (booted) return;
    booted = true;
    const script = document.createElement('script');
    script.defer = true;
    script.src = 'https://studio.anagram.ai/boot.js';
    script.setAttribute('data-experience', embed.getAttribute('data-anagram-experience'));
    embed.appendChild(script);
  };

  const observer = new MutationObserver(() => {
    if (modal.hasAttribute('open')) {
      bootExperience();
      observer.disconnect();
    }
  });
  observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
});
